(function(root) {
    'use strict';
    function Loupe(el) {
        this.init(el);
    }
    var canPoint = document.createElement('x');
    canPoint.style.cssText = 'pointer-events:none';
    canPoint = canPoint.style.pointerEvents === 'none';
    var _offset = 'offset';
    var _mousemove = 'mousemove';
    var _mouseout = 'mouseout';
    var _pointerdown = 'pointerdown';
    var _touchstart = 'touchstart';
    var _wheel = 'wheel';
    function eventOffset(event, axis) {
        return event[_offset + axis] === undefined ? event['layer' + axis] - event.target[_offset + (axis === 'X' ? 'Left' : 'Top')] : event[_offset + axis];
    }
    function intify(number) {
        return parseInt(number, 10);
    }
    function setClass(el, add, remove) {
        var string = el.className;
        remove = remove || '';
        el.className = (string.replace(remove, '') + ' ' + add).replace(/^\s*([\S\s]*)\b\s*$/, '$1');
    }
    Loupe.prototype = {
        _: {},
        classes: {
            lens: 'loupe',
            on: 'loupe--active',
            off: 'loupe--inactive'
        },
        on: false,
        zoom: 2,
        range: [1.2, 7],
        init: function(el) {
            var _this = this;
            if (!canPoint) {
                return;
            }
            _this._ = {};
            _this.range = _this.range.slice(0);
            _this.el = el;
            _this.render();
            _this.listen();
        },
        show: function() {
            if (!this.on) {
                setClass(this.lens, this.classes.on, this.classes.off);
                this.on = true;
            }
        },
        hide: function() {
            setClass(this.lens, this.classes.off, this.classes.on);
            this.on = false;
        },
        render: function() {
            var _this = this;
            _this.lens = document.createElement('div');
            _this.lens.className += ' ' + _this.classes.lens;
            document.body.appendChild(_this.lens);
        },
        image: function(imageEl) {
            var _this = this;
            if (_this._.l === imageEl) {
                return _this._.s;
            }
            _this._.l = imageEl;
            var newS;
            var el = imageEl;
            var els = [];
            while (el && !newS) {
                els.unshift(el);
                el = el.parentNode;
                if (el && el.nodeName === 'A') {
                    newS = el.href;
                }
            }
            if (!newS) {
                newS = imageEl.src;
            }
            _this._.s = newS;
            return newS;
        },
        refresh: function() {
            var _this = this;
            var style = _this.lens.style;
            var event = arguments[0] || _this._.e;
            if (event && event.target) {
                style.backgroundImage = 'url("' + _this.image(event.target) + '")';
            }
            if (_this._.e) {
                var elComputedStyle = getComputedStyle(event.target);
                var loComputedStyle = getComputedStyle(_this.lens);
                _this.show();
                style.transform = style.webkitTransform = 'translate(' + event.pageX + 'px,' + event.pageY + 'px)';
                _this.lens.style.backgroundSize = intify(elComputedStyle.width) * _this.zoom + 'px ' + intify(elComputedStyle.height) * _this.zoom + 'px';
                _this.lens.style.backgroundPosition = (0 - eventOffset(event, 'X') * _this.zoom + (intify(loComputedStyle.width) / 2)) + 'px ' + (0 - eventOffset(event, 'Y') * _this.zoom + (intify(loComputedStyle.height) / 2 | 0)) + 'px';
            }
            _this._.e = event;
        },
        destroy: function() {
            var _this = this;
            var elRemoveListener = _this.el.removeEventListener.bind(_this.el);
            if (_this.lens) {
                _this.lens.parentNode.removeChild(_this.lens);
                _this.lens = null;
            }
            if (_this._[_mousemove]) {
                elRemoveListener(_touchstart, _this._[_touchstart]);
                elRemoveListener(_pointerdown, _this._[_pointerdown]);
                elRemoveListener(_mousemove, _this._[_mousemove]);
                elRemoveListener(_mouseout, _this._[_mouseout]);
                elRemoveListener(_wheel, _this._[_wheel]);
            }
            _this._ = {};
        },
        listen: function() {
            var isTouched;
            var _this = this;
            var elAddListener = _this.el.addEventListener.bind(_this.el);
            _this._[_touchstart] = function() {
                isTouched = true;
            }
            ;
            _this._[_pointerdown] = function(event) {
                if (event.pointerType === 'touch') {
                    isTouched = true;
                }
            }
            ;
            _this._[_mousemove] = function(event) {
                if (!isTouched) {
                    _this.refresh.call(_this, event);
                }
                isTouched = false;
            }
            ;
            _this._[_mouseout] = _this.hide.bind(_this);
            elAddListener(_touchstart, _this._[_touchstart]);
            elAddListener(_pointerdown, _this._[_pointerdown]);
            elAddListener(_mousemove, _this._[_mousemove]);
            elAddListener(_mouseout, _this._[_mouseout]);
            _this._[_wheel] = _this.wheel.bind(_this);
            elAddListener(_wheel, _this._[_wheel]);
        },
        wheel: function(event) {
            var _this = this;
            var zoom;
            if (_this.on) {
                zoom = _this.zoom + event.deltaY * 0.1;
                zoom = (zoom < _this.range[0] ? _this.range[0] : (zoom > _this.range[1] ? _this.range[1] : zoom));
                _this.zoom = zoom;
                _this.refresh(event);
                event.preventDefault();
            }
        }
    };
    if (typeof define === 'function' && define.amd) {
        define([], function() {
            return Loupe;
        });
    } else if (typeof module === 'object' && module.exports) {
        module.exports = Loupe;
    } else {
        root.Loupe = Loupe;
    }
}(this));
